module.exports = __webpack_public_path__ + "static/media/logo.e0c8600c.png";